// extracted by mini-css-extract-plugin
export default {"wrapper":"CoinList_wrapper__eUEtc","leftSection":"CoinList_leftSection__jME7R","price":"CoinList_price__LawLZ","delete":"CoinList_delete__2qJ+U","loading":"CoinList_loading__Az6r4"};